import { render } from "./ContractModelShow.vue?vue&type=template&id=8b812760&scoped=true"
import script from "./ContractModelShow.vue?vue&type=script&lang=js"
export * from "./ContractModelShow.vue?vue&type=script&lang=js"

import "./ContractModelShow.vue?vue&type=style&index=0&id=8b812760&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8b812760"]])

export default __exports__